import { ActionTree } from 'vuex';
import { IVideoLinkState } from '@/video/link/store/video-link.types';
import {
  EVideoLinkAction,
  EVideoLinkMutation,
  state as defaultState,
} from '@/video/link/store/video-link.constants';
import { RootState } from '@/store/store';
import { translate } from '@/helpers/translation.helper';
import { VideoLinkHelper } from '@/video/link/helpers/video-link.helper';
import { VideoService } from '@/api/video/services/video.service';
import { EVideoSource } from '@/video/types/enums/video-source';
import { IVideo } from '@/types/Video';

export const actions: ActionTree<IVideoLinkState, RootState> = {
  [EVideoLinkAction.SetURL]({ commit, dispatch }, url: string) {
    commit(EVideoLinkMutation.SetVideoURL, url);
    commit(EVideoLinkMutation.SetFeedbackMessage, defaultState.feedbackMessage);
    if (!url) {
      commit(EVideoLinkMutation.TogglePreview, false);
      return;
    }
    const urlValid: boolean =
      VideoLinkHelper.getVimeoURLValidation(url).valid ||
      VideoLinkHelper.getYoutubeURLValidation(url).valid;
    if (!urlValid) {
      commit(EVideoLinkMutation.SetFeedbackMessage, translate('invalid-video-url').toString());
    } else {
      dispatch(EVideoLinkAction.SetTitle, '');
      dispatch(EVideoLinkAction.TogglePreview, true);
    }
  },
  [EVideoLinkAction.TogglePreview]({ commit }, show: boolean) {
    commit(EVideoLinkMutation.TogglePreview, show);
  },
  async [EVideoLinkAction.CreateVideo]({ commit, state, dispatch }) {
    commit(EVideoLinkMutation.SetLoading, true);
    try {
      const { url, title }: { url: string; title: string } = state;
      const source: EVideoSource = VideoLinkHelper.getVideoSource(url);
      const video: IVideo = await VideoService.createVideoLink(url, title, source);
      dispatch(EVideoLinkAction.CreateVideoSuccess, video);
    } catch (error) {
      dispatch(EVideoLinkAction.CreateVideoFailed);
    }
  },
  [EVideoLinkAction.CreateVideoSuccess]({ commit }, video: IVideo) {
    commit(EVideoLinkMutation.SetCreatedVideo, video);
  },
  [EVideoLinkAction.CreateVideoFailed]({ commit }) {
    commit(EVideoLinkMutation.SetLoading, false);
  },
  [EVideoLinkAction.SetTitle]({ commit }, title: string) {
    commit(EVideoLinkMutation.SetVideoTitle, title);
  },
  [EVideoLinkAction.ClearData]({ commit }) {
    commit(EVideoLinkMutation.ResetState, { ...defaultState });
  },
};
